import { render, staticRenderFns } from "./currency-input.vue?vue&type=template&id=00fc7210&scoped=true&"
import script from "./currency-input.vue?vue&type=script&lang=js&"
export * from "./currency-input.vue?vue&type=script&lang=js&"
import style0 from "./currency-input.vue?vue&type=style&index=0&id=00fc7210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc7210",
  null
  
)

export default component.exports